import { Slot } from '@radix-ui/react-slot'
import { clsx } from 'clsx'
import type { ComponentProps, ReactNode } from 'react'

import styles from './Button.module.scss'

export interface ButtonProps extends Omit<ComponentProps<'button'>, 'size'> {
  asChild?: boolean
  children: ReactNode
  variant:
    | 'add'
    | 'danger-secondary'
    | 'danger'
    | 'danger-link'
    | 'github'
    | 'inline-link'
    | 'link-alt'
    | 'link'
    | 'primary'
    | 'secondary'
    | 'unstyled'
  size?: 'compact' | 'large'
}

export function Button(props: ButtonProps): ReactNode {
  const { asChild, children, className, disabled, size, variant, type, ...rest } = props
  const Root = asChild ? Slot : 'button'
  const buttonType = !asChild ? (type ?? 'button') : undefined

  return (
    <Root
      type={buttonType}
      className={clsx(
        {
          [styles.btn]: variant !== 'unstyled',
          [styles['btn--add']]: variant === 'add',

          [styles['btn--danger-secondary']]: variant === 'danger-secondary',
          [styles['btn--danger']]: variant === 'danger' || variant === 'danger-link',
          [styles['btn--github']]: variant === 'github',
          [styles['btn--large']]: size === 'large',
          [styles['btn--link']]:
            variant === 'link-alt' || variant === 'link' || variant === 'danger-link',
          [styles['btn--link-alt']]: variant === 'link-alt',
          [styles['btn--inline-link']]: variant === 'inline-link',
          [styles['btn--primary']]: variant === 'primary' || variant === 'add',
          [styles['btn--secondary']]: variant === 'secondary',
          [styles['btn--unstyled']]: variant === 'unstyled',
          [styles['btn--compact']]: size === 'compact',
          [styles['btn--large']]: size === 'large',
          [styles['btn--disabled']]: disabled,
        },
        className,
      )}
      disabled={disabled}
      {...rest}
    >
      {children}
    </Root>
  )
}
